import React from 'react'
import Headerbar  from "./components/common/Headerbar";
import Titlebar  from "./components/common/Titlebar";
import VendorUpdateForm from './components/payment_approval/VendorUpdateForm';

function UpdateVendor() {
  return (
    <><Headerbar /><Titlebar name="Update Vendor Form" /><VendorUpdateForm/></>
  )
}

export default UpdateVendor